import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBell, FaRegBellSlash } from "react-icons/fa";

import FootpringSvg from "../../../assets/splash-nico-hi.png";
import FootprintLogo from "../../../assets/Footprints_Logo-White.svg";
import "../SideMenu/SideDrawer.css";

import { useAtom } from "jotai";
import {
  activeChildDetail,
  alertModal,
  appConstants,
  bell,
  changeChild,
  childList,
  deviceFCMToken,
  mobileAtom,
  permaStatus,
  sidebar,
} from "../../../AtomStore/store";
import altprofile from "../../../Pages/components/assets/pictures/profile.png";
import { PushNotifications } from "@capacitor/push-notifications";
import NotificationService from "../../../Components/utils/NotificationService";
import { StyledGoDot } from "./styles";
import Constants from "../../../constants";
import { getDeviceToken } from "../../../AtomStore/ServiceAtoms";
import { useRequestProcessor } from "../../../requestProcessor";
import { ReloadData, saveToken } from "../../../QueryFunctions/queryfunction";

export const getFullPath = (constants, path) => {
  if (typeof path === "string" && path.startsWith("https")) {
    return path;
  } else if (typeof path === "string" && path.length === 0) {
    return path;
  } else {
    return constants?.ImagePath + path;
  }
};

const NewHeader = () => {
  const [child] = useAtom(childList);
  const [mobile] = useAtom(mobileAtom);
  const [showModal, setShowModal] = useAtom(alertModal);
  const [permStatus, setPermStatus] = useAtom(permaStatus);
  const [showBell, setShowBell] = useAtom(bell);
  const [, setCollapse] = useAtom(sidebar);
  const [activeChild] = useAtom(activeChildDetail);
  const [, setShowOverlay] = useAtom(changeChild);
  const [constants] = useAtom(appConstants);
  const [, setImgSrc] = useState();
  const [showNotificationService, setShowNotificationService] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { useMutationWrapper } = useRequestProcessor();

  const reloadData = useMutationWrapper(
    "reload",
    () => {
      return ReloadData(navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[newHeader] Reload child data response:", data);
      },
    }
  );
  const saveTokenFn = useMutationWrapper(
    "saveToken",
    (token) => {
      return saveToken(token);
    },
    {
      onSuccess: (data) => {
        reloadData.mutate();
      },
    }
  );

  useEffect(() => {
    setImgSrc();
  }, [activeChild]);

  const pathname = location.pathname;

  let headName = "Default Page";

  switch (true) {
    case pathname.includes("/login"):
      headName = "Login";
      break;
    case pathname.includes("/verify"):
      headName = "Verify";
      break;
    case pathname.includes("/dashboard"):
      headName = "Dashboard";
      break;
    case pathname.includes("/blogs"):
      headName = "Blogs";
      break;
    case pathname.includes("/food") || pathname.includes("/Food"):
      headName = "Food Menu";
      break;
    case pathname.includes("/outdoorActivity") ||
      pathname.includes("/OutdoorActivity"):
      headName = "Outdoor Activity";
      break;
    case pathname.includes("/calendar"):
      headName = "Activity Calendar";
      break;
    case pathname.includes("/timeline"):
      headName = "Child Timeline";
      break;
    case pathname.includes("/chat"):
      headName = "Conversation";
      break;
    case pathname.includes("/growth"):
      headName = "Growth";
      break;
    case pathname.includes("/holidayCalendar"):
      headName = "Holiday Calendar";
      break;
    case pathname.includes("/PastRequestTab"):
      headName = "Request";
      break;
    case pathname.includes("/center"):
      headName = "My Center";
      break;
    case pathname.includes("/support"):
      headName = "Support";
      break;
    case pathname.includes("/myProfile"):
      headName = "My Profile";
      break;
    case pathname.includes("/Pause"):
      headName = "Take A Break";
      break;
    case pathname.includes("/ShiftCentre"):
      headName = "Shift Centre";
      break;
    case pathname.includes("/ChangeProgram"):
      headName = "Change Program";
      break;
    case pathname.includes("/WithrawChild"):
      headName = "Child Withdraw";
      break;
    case pathname.includes("/extendedDaycare"):
      headName = "Extended Daycare";
      break;
    case pathname.includes("/earlyResume"):
      headName = "Early Resume";
      break;
    case pathname.includes("/extendPause"):
      headName = "Extend Pause";
      break;
    case pathname.includes("/raiseAnIssue"):
      headName = "Submit Issue";
      break;
    case pathname.includes("/news"):
      headName = "News";
      break;
    case pathname.includes("/nonSatisfaction"):
      headName = "Submit Refund";
      break;
    case pathname.includes("/feeCertificate"):
      headName = "Fee Certificate";
      break;
    case pathname.includes("/shareCertificate"):
      headName = "Share Certificate";
      break;
    case pathname.includes("/Transport"):
      headName = "Transport";
      break;
    case pathname.includes("/Finance"):
      headName = "finance";
      break;
    case pathname.includes("/attendance"):
      headName = "Attendance";
      break;
    case pathname.includes("notification"):
      headName = "Notifications";
      break;
    case pathname.includes("activityCalendar"):
      headName = "Activity Calendar";
      break;
    case pathname.includes("photoGallery") || pathname.includes("PhotoGallery"):
      headName = "My Photos";
      break;
    case pathname.includes("parentVideo"):
      headName = "Videos";
      break;
    case pathname.includes("cctv"):
      headName = "Live CCTV";
      break;
    case pathname.includes("shareFeeCerticate"):
      headName = "Share ";
      break;
    // Add more cases as needed
    default:
      headName = "Default Page";
  }

  console.log("permission status in header", activeChild);
  const handleImageError = (e) => {
    e.target.src = altprofile;
  };
  let dbDeviceToken = "";
  if (Constants.env.web === "yes") {
    dbDeviceToken =
      activeChild?.parent === "Father"
        ? activeChild?.father_web_token
        : activeChild?.mother_web_token;
  } else {
    dbDeviceToken =
      activeChild?.parent === "Father"
        ? activeChild?.father_arn
        : activeChild?.mother_arn;
  }
  // dbDeviceToken = "";
  console.log("dbDeviceToken : ", dbDeviceToken);
  return (
    <>
      <div className="fixed-top bg-header shadow h-[70px] md:h-[65px] flex bg-[#19ade4]">
        <div className="grow flex items-center pl-3">
          {/* <div className="h-8 w-8 bg-white rounded-full flex items-center justify-center">
            <FaAngleLeft style={{ color: '#00A4E1', fontSize: 25 }} />
          </div> */}
          <button
            className="md:hidden"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setCollapse(true);
            }}
          >
            <i className="bi bi-list text-white text-3xl"></i>
          </button>
          <div className="ml-2 flex items-center gap-2 cursor-pointer">
            <img src={FootpringSvg} className="h-12" alt="logo" />
            <img
              src={FootprintLogo}
              className="h-4 hidden md:block"
              alt="logo"
            />
          </div>
          <div className="text-white grow uppercase flex justify-center font-extrabold text-sm md:text-lg md:tracking-wider">
            {headName.toUpperCase()}
          </div>
          {/* <div className="absolute md:right-44 right-[85px]">
            <GoTriangleLeft style={{ color: '#ffffff', fontSize: 60 }} />
          </div> */}
        </div>
        <div className="flex justify-end px-2">
          <div
            className=" h-[70px] md:h-[65px] flex items-center justify-end mr-2 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              navigate("/notification");
            }}
          >
            {permStatus?.receive === "granted" && dbDeviceToken ? (
              <div className="">
                <Link
                  className="d-flex align-items-center"
                  to="/notification"
                  onClick={() => {
                    setShowBell(false);
                  }}
                >
                  <i
                    className="icon-notification"
                    style={{ fontSize: "1.5em", color: "#ffffff" }}
                  />
                  {showBell ? <StyledGoDot /> : <></>}
                </Link>
              </div>
            ) : (
              <FaRegBellSlash
                className="text-3xl text-red "
                onClick={async () => {
                  if (mobile) {
                    const permissionStatus =
                      await PushNotifications.requestPermissions();
                    if (permissionStatus.receive === "granted") {
                      if (getDeviceToken()) {
                        saveTokenFn.mutate(getDeviceToken());
                      } else {
                        setShowNotificationService(true);
                      }
                    } else {
                      setShowModal({
                        ...showModal,
                        state: true,
                        type: "Error",
                        message:
                          "Please Unblock Notification Request Manually, To receive your updates from footprints",
                      });
                    }
                  } else {
                    const permissionStatus =
                      await Notification.requestPermission();

                    if (permissionStatus === "granted") {
                      if (getDeviceToken()) {
                        saveTokenFn.mutate(getDeviceToken());
                      } else {
                        setShowNotificationService(true);
                      }
                    } else {
                      setShowModal({
                        ...showModal,
                        state: true,
                        type: "Error",
                        message:
                          "Please Unblock Notification Request Manually, To receive your updates from footprints",
                      });
                    }
                  }
                }}
              />
            )}

            {showNotificationService && <NotificationService />}
          </div>
          <div
            className="flex justify-center items-center cursor-pointer"
            onClick={() => {
              if (child?.length === 1) {
                navigate("/myProfile");
              } else {
                setShowOverlay(true);
              }
            }}
          >
            {Array.isArray(child) && child.length > 1 ? (
              <div className="relative w-16 h-10 flex items-center">
                {/* Non-active child */}
                <img
                  src={
                    getFullPath(
                      constants,
                      child.find((c) => c.id !== activeChild?.id)?.child_photo
                    ) || altprofile
                  }
                  alt="Other Child"
                  className="rounded-full w-10 h-10  absolute left-4 z-0 object-cover"
                  onError={handleImageError}
                />
                {/* Active child (overlapping) */}
                <img
                  src={
                    getFullPath(constants, activeChild?.child_photo) ||
                    altprofile
                  }
                  style={{ border: "1px solid white" }}
                  alt={activeChild?.name}
                  className="rounded-full w-10 h-10 !border-2 !border-white absolute left-0 z-10 object-cover"
                  onError={handleImageError}
                />
              </div>
            ) : (
              <img
                src={
                  getFullPath(constants, activeChild?.child_photo) || altprofile
                }
                alt={activeChild?.name}
                className="rounded-full w-10 h-10 border-2 border-white border-opacity-80 object-cover"
                onError={handleImageError}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewHeader;
